<template>
    <div></div>
</template>
<script>
    export default {
        name: 'splashscreen',
        mounted() {
            this.close();
        },
        methods: {
            close() {
                setTimeout(() => {
                    $('.dd-m-splashscreen').fadeOut('fast');
                }, 500);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/splashscreen.vue